import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --font-montserrat: 'Montserrat', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --font-commissioner: 'Commissioner', var(--font-montserrat);
    --font-bebas: 'Bebas Neue', var(--font-montserrat);
    --font-manrope: 'Manrope', var(--font-montserrat);
  }

  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }

  body {
    margin: 0;
    min-height: 100vh;
    background: ${({ theme }) => theme.colors.background};
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: var(--font-montserrat);
    font-weight: 500;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  *::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.text.disabled};
    border-radius: 6px;
  }

  button {
    border: 0;
    background: none;
    padding: 0;
    cursor: pointer;
    font-family: inherit;
  }

  a {
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: none;
    transition: color 150ms;

    &:hover {
      color: ${({ theme }) => theme.colors.primary.dark};
    }
  }
`;
